import { actions } from "@/store/modules/delayCodes/actions";
import { mutations } from "@/store/modules/delayCodes/mutations";
import { state } from "@/store/modules/delayCodes/state";

/**
 * Example module for VueX
 */

export default {
  namespaced: true as true,
  state,
  actions,
  mutations
};
